module.exports = __webpack_public_path__ + "static/media/homedemo.7c76679d.svg";